import type { UseQueryResult } from '@tanstack/react-query';
import { useTestInstanceResponseMark } from 'services/assist-api/entities/test-instance-response-mark/hooks';
import type { TestInstanceResponseMarkWithItems } from 'services/assist-api/entities/test-instance-response-mark/types';

/**
 * Fetches the mark (with mark items) that can be viewed or changed on a Mark Response page.
 */
export default function useMarkForMarking(
  markId: string | null | undefined
): UseQueryResult<RequestResponse<TestInstanceResponseMarkWithItems>, RequestError> {
  return useTestInstanceResponseMark<TestInstanceResponseMarkWithItems>(markId, {
    groups: [
      'id', // Adds the ID field to all subentities as well

      'testinstanceresponsemark-markitems',
      'testinstanceresponsemarkitem-submittedvalue',
      'testinstanceresponsemarkitem-testrubricitem',
      'testinstanceresponsemarkitem-submittedoptions',
      'testinstanceresponsemarkitem-testinstanceresponsemarker', // The marker of the mark item
      'testinstanceresponsemarkitem-inputtype',
      'testinstanceresponsemarkitem-testinstanceresponseitem',

      // The organisation user of both the mark's active marker and each mark item's marker:
      'testinstanceresponsemarker-user',

      // The attention reasons associated with the mark:
      'testinstanceresponsemark-tags'
    ],
    include: 'markItems,markers,tags'
  });
}
